import type { NavigateOptions } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import { useRouter } from 'next/navigation'

import { saveDepthToHistory, useNavigationStore } from '@/stores/navigationStore'

export const useWebviewNavigation = () => {
  const router = useRouter()
  const { incrementDepth, decrementDepth } = useNavigationStore()

  const push = (href: string, options?: NavigateOptions) => {
    router.push(href, options)

    // router.push가 완료된 후 태스크 실행을 위한 로직이며 depth를 history.state에 저장합니다.
    setTimeout(() => {
      const newDepth = incrementDepth()
      saveDepthToHistory(newDepth)
    }, 0)
  }

  const back = () => {
    router.back()
    // back 시에는 popstate 이벤트로 이전 depth가 복원되므로 store에만 업데이트를 합니다.
    decrementDepth()
  }

  const replace = (href: string, options?: NavigateOptions) => {
    router.replace(href, options)

    // replace는 depth를 변경하지 않고 현재 엔트리만 업데이트합니다.
    setTimeout(() => {
      const currentDepth = useNavigationStore.getState().depth
      saveDepthToHistory(currentDepth)
    }, 0)
  }

  return { push, back, replace }
}
